import MessagingHeader from "./App/MessagingHeader";
import MessagingBody from "./App/MessagingBody";
import { useAtom } from 'jotai';
import LoadingMessages from "./App/LoadingMessages";
import { serviceSync } from '../services/sync.service';
import { useEffect } from "react";
import { libMisc } from "../lib/misc";
import MessagingConversationsColumn from "./App/MessagingConversationsColumn";
import MessagingMessagesBody from "./App/MessagingMessagesBody";
import { s } from "../lib/styler";
import { useSingleEffect } from "../lib/hooks/SingleEffect.hook";

export default function App() {
    const [appLoaded] = useAtom(serviceSync.atomAppLoaded);
    const [_, setSearchShortcutCounter] = useAtom(serviceSync.atomSearchShortcutCounter);
    const [mobileThreadOpen, setMobileThreadOpen] = useAtom(serviceSync.atomMobileThreadOpen);

    useEffect(() => {
        let cb: any;
        document.addEventListener("keydown", cb = (event: KeyboardEvent) => {
            const modKey = libMisc.isMac ? event.metaKey : event.ctrlKey;

            if (modKey && event.key.toLowerCase() === "f") {
                event.preventDefault();
                setSearchShortcutCounter((x) => x + 1);
            }
        });
        return () => {
            document.removeEventListener("keydown", cb);
        };
    }, []);

    return (
        <div className="fixed left-0 top-0 h-full w-full">
            {appLoaded && (
                <div className="w-full h-full flex relative">
                    <div className="w-full md:basis-[298px] md:w-auto">
                        <MessagingConversationsColumn />
                        {/* <MessagingHeader /> */}
                    </div>
                    <div className={s("transition-all duration-200 md:pointer-events-auto md:translate-y-[0px] md:opacity-100 md:flex-grow md:border-l md:border-gray-300 md:block absolute left-0 top-0 w-full h-full md:static md:w-auto md:h-auto", {}, [
                        ["opacity-100 pointer-events-auto translate-y-[0px]", "translate-y-[40px] opacity-0 pointer-events-none", mobileThreadOpen]
                    ])}>
                        <MessagingMessagesBody />
                        {/* <MessagingBody /> */}
                    </div>
                </div>
            )}
            {!appLoaded && (
                <LoadingMessages />
            )}
        </div>
    );
}